import { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';

import { Customer, } from '../../classess/customer/customer';

import { GlobalFormats } from '../../classess/main/globalFormats';

import ServiceDocumentDetails from './ServiceDocumentDetails';

import {
    getProcessButtons, dataTableLanguaje, setDateTimeFormatGlobalString, getDtRowIndex, isUndNull, isUndNullEmp, getLanguageObj,
    getResponse, getRolesType, handleResponseMessageAsync, settings, styles, getUserRoles, LoadingSection, awaitDelayAsync,
} from '../../helpers/main';
import useAuth from '../../auth/UseAuth';
import Menu from '../main/Menu';
import { DigitizedDocument } from '../../classess/main/digitizedDocument';
import { DataCenterService } from '../../services/dataCenters/DataCenterService';
import TableIndex from '../main/TableIndex';
import AccessDenied from '../main/AccessDenied';

const $ = window.jqGlobal || window.jQuery;

const { app, backend, html, icons, images, labels, messages, timers } = settings;

const currentMethod = 'DataCenterEdit';

export default function DataCenterEdit({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
}) {
    //#region variables
    const auth = useAuth();
    const { type = '', id = 0 } = useParams();
    const [viewType] = useState(type === labels?.edit?.en?.toLowerCase() ?
        1 :
        (type === labels?.details?.en?.toLowerCase() ? 2 : 0));

    const userRole = auth?.userRole({ languageId: languageObj?.id, subMethod: currentMethod })?.result || '';
    let userRoles = getRolesType();
    userRoles = getUserRoles({ userRole: userRole, subMethod: currentMethod, })?.result;
    const dtDocumentInformationsId = 'dtDocumentInformations';
    const dtServiceDocumentsId = 'dtServiceDocuments';
    const isMount = useRef(true);
    const btnDetailRef = useRef(null);
    const [showData, setShowData] = useState(true);
    const [process, setProcess] = useState({
        showLoading: true,
        detail: false,
        back: false,
    });
    const brdFieldViewsObj = {
        status: {
            label: '',
            badget: '',
        },
        scheduledDate: {
            date: '',
            time: ''
        },
        executionDate: {
            date: '',
            time: ''
        },
        commentary: '',
    };
    const [modalObj, setModalObj] = useState({
        $: $,
        type: 0,
        auth: auth,
        brdFieldViews: brdFieldViewsObj,
        languageObj: languageObj,
        dtServiceDocumentsId: dtServiceDocumentsId,
        dtServiceDocumentsRowId: 0,
        sdShowModal: false,
        serviceDocument: DigitizedDocument?.getClass({}, false),
        showModal: false,
        userRoles: userRoles,
    });
    const controls = {
        buttons: {
            detail: {
                defaultClass: 'btn btn-outline-secondary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnAddDataCenter',
            },
            back: {
                defaultClass: 'btn btn-outline-secondary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnBack',
            },
        },
        checkBoxs: {
            isActive: {
                id: 'chkIsActive',
                defaultClass: '',
            },
        },
        dataTables: {
            dataCenters: {
                inputs: {
                    search: {
                        id: `${dtServiceDocumentsId}_filter input`,
                        defaultClass: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtServiceDocumentsId}_length select`,
                        defaultClass: '',
                    },
                },
                paginateds: {
                    paginated: {
                        id: `${dtServiceDocumentsId}_paginate`,
                        defaultClass: '',
                    },
                },
            },
            columns: {
                process: {
                    id: 5,
                },
            },
        },
        icons: {
            detail: {
                id: 'iconDetail',
                defaultClass: icons?.fasFa?.list,
            },
            back: {
                id: 'iconBack',
                defaultClass: icons?.fasFa?.arrowCircleLeft,
            },
        },
        inputs: {
            number: {
                id: 'inpuntNumber',
                defaultClass: 'form-control text-black bg-transparent',
                //defaultClass: 'form-control',
            },
            dateBegin: {
                id: 'inputDateBegin',
                defaultClass: 'form-control datetimepicker-input',
                //defaultClass: 'form-control text-black bg-transparent datetimepicker-input',
            },
        },
        pickers: {
            dateBegin: {
                id: 'pkRegisterDate',
            },
        },
        selects: {
            customers: {
                id: 'selCustomer',
                //defaultClass: 'custom-select text-black bg-transparent',
                defaultClass: 'custom-select',
            },
        },
        spiners: {
            detail: {
                id: 'spDetail',
                defaultClass: '',
            },
            back: {
                id: 'spBack',
                defaultClass: '',
            },
        },
        textAreas: {
            commentary: {
                id: 'txtAreaCommentary',
                //defaultClass: 'form-control text-black bg-transparent',
                defaultClass: 'form-control',
            }
        }
    };
    const [dataInfo, setDataInfo] = useState({ id: 0, description: '', rowId: 0, type: 0, });
    const urlBack = `${backend?.urls?.dataCenters}/`;
    const [customer, setCustomer] = useState(Customer?.getClass({}, false));
    const [serviceDocuments, setServiceDocuments] = useState([DigitizedDocument?.getClass({}, false)]);
    //#endregion methods

    //#region methods
    //#region datacenter
    const getDataCenterEditDetail = async ({
        e = undefined,
        id = 0,
        description = '',
        rowId = 0,
        type = 2,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getDataCenterEditDetail';
        try {
            e?.preventDefault?.();

            setProcess(prev => ({ ...prev, detail: true, showLoading: true }));

            // Update dataInfo (visual/state sync)
            const currentDataInfo = { id, description, rowId, type };
            setDataInfo(prev => ({
                ...prev,
                ...currentDataInfo
            }));

            // Directly show the detail instead of triggering a click
            response = showServiceDocumentDetail({
                _dataInfo: currentDataInfo,
                subMethod: currentMethod,
            });

        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, detail: false, showLoading: false }));

            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response, currentMethod, auth,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const showServiceDocumentDetail = ({
        _dataInfo = {},
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'showServiceDocumentDetail';
        try {
            const dataToFilter = _dataInfo?.id ? _dataInfo : dataInfo;
            //TODO: see how the modal behaves
            setModalObj(prev => ({
                ...prev,
                serviceDocument: serviceDocuments?.filter(({ type, number }) => type === dataToFilter?.description && number === dataToFilter?.id)[0] || {},
                dtServiceDocumentsRowId: dataToFilter?.rowId,
                type: dataToFilter?.type,
                sdShowModal: true,
            }));
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }
    //#endregion datacenter

    //#region others
    const getData = async ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getData';
        try {
            setProcess(prev => ({ ...prev, showLoading: true }));

            if (auth?.isLoged({ subMethod: currentMethod })?.result) {
                //#region variables
                let customerData = Customer?.getClass({}, false);
                let serviceDocumetsData = [DigitizedDocument?.getClass({}, false)];
                let documentInformationsData = [DigitizedDocument?.getClass({}, {})];
                //#endregion variables

                //#region check type (url)
                if (viewType !== 2) {
                    window.location.href = `${backend?.urls?.notFound}`;
                    return;
                }
                //#endregion check type (url)

                //#region datatable (set)
                response = setDataTables({ subMethod: currentMethod });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion datatable (set)

                //#region set query code
                response = setQueryCode({ subMethod: currentMethod });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion set query code

                //#region check role
                if (viewType === 1 && !userRoles?.isAdmin && !userRoles?.isAnalyst) {
                    response = getResponse({
                        type: 1,
                        msgText: `${messages?.youDoNotHaveSufficientPrivilegesToRunThisProcess?.[languageObj?.id]}.`,
                    });
                    response.urlGoTo = urlBack;
                    return;
                }
                //#endregion check role

                //#region get data (datacenter)
                response = await DataCenterService.getById({
                    auth: auth,
                    id: id,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                if (!response?.isSuccess || response?.isWarning) {
                    response.urlGoTo = urlBack;
                    return;
                }

                //#region set data
                customerData = response?.result?.customer || {};
                setCustomer(customerData);
                serviceDocumetsData = response?.result?.dataCenters || {};
                setServiceDocuments(serviceDocumetsData);
                documentInformationsData = response?.result?.digitizedDocuments || [];
                //#endregion set data

                if (isUndNullEmp({ data: customerData, subMethod: currentMethod })?.result) {
                    response = getResponse({
                        type: 1,
                        msgText: `${messages?.theRecordCannotBeLocated[languageObj?.id]}.<br/>`,
                    });
                    response.urlGoTo = urlBack;
                    return;
                }
                //#endregion get data (datacenter)

                //#region set datatable
                if ((!isUndNullEmp({ data: serviceDocumetsData, subMethod: currentMethod })?.result && serviceDocumetsData.length > 0) ||
                    (!isUndNullEmp({ data: documentInformationsData, subMethod: currentMethod })?.result && documentInformationsData.length > 0)) {
                    response = setDataInDataTable({
                        data: serviceDocumetsData,
                        documentInformations: documentInformationsData,
                        subMethod: currentMethod,
                    });
                    if (!response?.isSuccess || response?.isWarning) return;
                }
                //#endregion set datatable
            } else {
                setShowData(false);
                window.location.href = urlBack;
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            response.urlGoTo = urlBack;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false }));
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response, currentMethod, auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }

            // Preservation of window.location navigation if urlGoTo is set in response
            if (!isUndNullEmp({ data: response?.urlGoTo, subMethod: currentMethod })?.result) {
                window.location.href = response?.urlGoTo;
            }
        }
    }

    const goToBack = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'goToBack';
        try {
            e?.preventDefault?.();

            setProcess(prev => ({ ...prev, back: true, showLoading: true }));
            await awaitDelayAsync({ delayTime: timers?.oneSecond });

            window.location.href = urlBack;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, back: false, showLoading: false }));

            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response, currentMethod, auth,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const setDataTables = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setDataTables';
        try {
            //#region document informations
            $(`#${dtDocumentInformationsId}`).DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.row[languageObj?.id], width: '10%', orderable: false, },
                    { title: labels?.type?.[languageObj?.id], width: '10%', orderable: false, },
                    { title: labels?.document?.[languageObj?.id], width: '10%', orderable: false, },
                    { title: labels?.description?.[languageObj?.id], width: '65%', orderable: false, },
                    { title: labels?.file[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ code: languageObj?.id, }),
                //order: [[0, 'asc'], [1, 'asc']],
                //order: [[0, 'desc'],],
                responsive: true,
                lengthChange: false,
                autoWidth: false,
                info: false,
                ordering: false,
                paging: false,
                searching: false,
            });
            //.buttons().container().appendTo(`#${dtServiceDocumentsId}_wrapper .col-md-6:eq(0)`);
            //#endregion document informations

            //#region datacenters
            $(`#${dtServiceDocumentsId}`).DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: 'dateTime', width: '0%', orderable: false, searchable: false, visible: false, },
                    { title: labels?.row[languageObj?.id], width: '10%', orderable: false, },
                    { title: labels?.type?.[languageObj?.id], width: '10%', orderable: false, },
                    { title: labels?.document?.[languageObj?.id], width: '10%', orderable: false, },
                    { title: labels?.date?.[languageObj?.id], width: '10%', orderable: false, },
                    {
                        title: labels?.daysToExpire?.[languageObj?.id], className: 'text-center', width: '15%', orderable: false,
                        render: function (data, type, row) {
                            try {
                                let newData = '';
                                const remainingDays = parseInt(data);
                                if (remainingDays >= 15) {
                                    newData = `<span class='text-success'>${data}</span>`;
                                } else if (remainingDays < 15 && remainingDays >= 1) {
                                    newData = `<span class='text-warning'>${data}</span>`;
                                } else {
                                    newData = `<span class='text-danger'>${data}</span>`;
                                }
                                return newData;
                            } catch (ex) {
                                return ex?.message;
                            }
                        },
                    },
                    { title: labels?.commentary?.[languageObj?.id], width: '35%', orderable: false, },
                    { title: labels?.file[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                    { title: labels?.process[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ code: languageObj?.id, }),
                //order: [[0, 'asc'], [1, 'asc']],
                order: [[0, 'asc'],],
                //ordering: false,
                responsive: true,
                lengthChange: true,
                autoWidth: false,
            });
            //.buttons().container().appendTo(`#${dtServiceDocumentsId}_wrapper .col-md-6:eq(0)`);
            //#endregion datacenters
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setQueryCode = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setQueryCode';
        try {
            //#region variables
            let id_ = '';
            let methodName = '';
            let description = '';
            let rowId = 0;
            //#endregion variables

            //#region process
            $(`#${dtServiceDocumentsId} tbody`).on('click', 'tr', 'td', async function (e) {
                rowId = getDtRowIndex({ dtId: dtServiceDocumentsId, _this: this, subMethod: currentMethod })?.result;
                if (!isUndNull({ data: rowId, subMethod: currentMethod })?.result) {
                    methodName = e?.target?.attributes?.method?.value || '';
                    id_ = e?.target?.attributes?.id?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (methodName) {
                        case 'details':
                            getDataCenterEditDetail({ e: e, id: parseInt(id_), description: description, rowId: rowId, type: 2, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDataInDataTable = ({
        data = [],
        documentInformations = [],
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setDataInDataTable';
        try {
            //#region variables
            let rowData = [];
            let urlDocument = '';
            let modelDigitizedDocument = DigitizedDocument?.getClass({}, false);
            //#endregion variables

            //#region process
            //#region digitizeddocument (document informations)
            rowData = [];
            documentInformations.forEach((documentInformation) => {
                //#region variables
                modelDigitizedDocument = DigitizedDocument?.getClass(documentInformation, false);
                urlDocument = isUndNullEmp({ data: modelDigitizedDocument?.urlDownload, subMethod: currentMethod })?.result ?
                    `<img alt='${modelDigitizedDocument?.rowNumber}' height='30' src='${images?.icons?.pdfNoAvailableIcon}' title='${modelDigitizedDocument?.description}' width='25'/>` :
                    `<a href='${modelDigitizedDocument?.urlDownload}' rel='noreferrer noopener' target='_blank'><img alt='${modelDigitizedDocument?.rowNumber}' height='30' src='${images?.icons?.pdfAvailableIcon}' title='${modelDigitizedDocument?.description}' width='25'/></a>`;
                //#endregion variables

                rowData.push([
                    modelDigitizedDocument?.rowNumber,
                    modelDigitizedDocument?.type,
                    modelDigitizedDocument?.numberStr,
                    modelDigitizedDocument?.description,
                    urlDocument,
                ]);
            });

            $(`#${dtDocumentInformationsId}`)?.DataTable()?.rows?.add(rowData)?.draw(true);
            //#endregion digitizeddocument (document informations)

            //#region digitizeddocument (service documents)
            rowData = [];
            data.forEach((dataCenter) => {
                //#region variables
                modelDigitizedDocument = DigitizedDocument?.getClass(dataCenter, false);
                const dateTime = modelDigitizedDocument?.emisionDate;
                const emisionDate = setDateTimeFormatGlobalString({
                    date: modelDigitizedDocument?.emisionDate,
                    dateFormat: languageObj?.format?.date?.f1,
                    timeFormat: 0,
                    withSeconds: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;

                const remainingDays = modelDigitizedDocument?.service?.remainingDays;
                urlDocument = isUndNullEmp({ data: modelDigitizedDocument?.urlDownload, subMethod: currentMethod })?.result ?
                    `<img alt='${modelDigitizedDocument?.rowNumber}' height='30' src='${images?.icons?.pdfNoAvailableIcon}' title='${modelDigitizedDocument?.description}' width='25'/>` :
                    `<a href='${modelDigitizedDocument?.urlDownload}' rel='noreferrer noopener' target='_blank'><img alt='${modelDigitizedDocument?.rowNumber}' height='30' src='${images?.icons?.pdfAvailableIcon}' title='${modelDigitizedDocument?.description}' width='25'/></a>`;
                const processButtons = [];
                //#endregion variables

                rowData.push([
                    dateTime,
                    modelDigitizedDocument?.rowNumber,
                    modelDigitizedDocument?.description,
                    modelDigitizedDocument?.number,
                    emisionDate,
                    remainingDays,
                    modelDigitizedDocument?.item?.description,
                    urlDocument,
                    getProcessButtons({
                        id: modelDigitizedDocument?.number,
                        description: modelDigitizedDocument?.type,
                        showDetails: true,
                        labelDetails: labels?.details?.[languageObj?.id],
                        enabledDetails: true,
                        showDelete: false,
                        labelDelete: labels?.delete?.[languageObj?.id],
                        enabledDelete: false,
                        showEdit: false,
                        labelEdit: labels?.edit?.[languageObj?.id],
                        enabledEdit: false,
                        processButtons: processButtons,
                    })?.result,
                ]);
            });

            $(`#${dtServiceDocumentsId}`)?.DataTable()?.rows?.add(rowData)?.draw(true);
            //#endregion digitizeddocument (service documents)
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => { isMount.current = false; };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others
    //#endregion methods
    return (
        <div>
            <Menu viewName={app?.views?.services?.services} process={app?.views?.dataCenter?.dataCenter} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{viewType === 1 ? labels?.edit?.[languageObj?.id] : labels?.details?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href='/'>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item'><a href={`${backend?.urls?.dataCenters}/`}>{labels?.dataCenters?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{viewType === 1 ? labels?.edit?.[languageObj?.id] : labels?.details?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        {auth?.isLoged({ subMethod: currentMethod })?.result ? (
                            <div className='row'>
                                <div className='col-12'>
                                    {showData ? (
                                        <div className={html?.cards?.default} style={{ borderRadius: '10px' }}>
                                            <LoadingSection alt='loadSection'
                                                className='overlay dark text-white'
                                                height={20}
                                                hidden={!process?.showLoading}
                                                width={20}
                                                languageId={languageObj?.id}
                                                subMethod={currentMethod} />

                                            <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                                <div className='d-flex align-items-center'>
                                                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <img alt={labels?.dataCenter?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={images?.icons?.dataCenters} />
                                                    </div>
                                                    <div className='d-flex flex-column'>
                                                        <h5 className='mb-0 font-weight-bold text-dark'>{labels?.dataCenter?.[languageObj?.id]}</h5>
                                                        <div className='mt-1'>
                                                            <span className={`badge badge-pill px-2 py-1 text-uppercase badge-secondary`}
                                                                style={settings?.html?.badges?.micro}>
                                                                <i className={`${icons?.fasFa?.dataBase} mr-1`}></i> {labels?.details?.[languageObj?.id] || 'Info'}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='card-body'>
                                                <div className='row'>
                                                    <div className='col-12 col-md-8 mb-3'>
                                                        <div className='p-3 rounded bg-light border-left border-primary shadow-sm h-100'
                                                            style={{ borderLeftWidth: '5px' }}>
                                                            <small className='text-muted text-uppercase font-weight-bold d-block mb-1'
                                                                style={html?.labels?.detailMicro}>
                                                                <i className={icons?.fasFa?.user} /> {labels?.customer?.[languageObj?.id]}
                                                            </small>
                                                            <span className='text-dark font-weight-bold'>
                                                                {`${customer?.rif || ''} ${customer?.name || ''}`.trim() || '---'}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className='col-12 col-md-4 mb-3'>
                                                        <div className='p-3 rounded bg-light border-left border-info shadow-sm h-100'
                                                            style={{ borderLeftWidth: '5px' }}>
                                                            <small className='text-muted text-uppercase font-weight-bold d-block mb-1'
                                                                style={html?.labels?.detailMicro}>
                                                                <i className={icons?.fasFa?.server} /> {labels?.service?.[languageObj?.id]}
                                                            </small>
                                                            <div className='d-flex align-items-center'>
                                                                <span className={`badge badge-pill ${serviceDocuments?.length > 0 ? 'badge-success' : 'badge-secondary'} px-2 py-1 text-uppercase font-weight-bold shadow-sm shadow-sm`}
                                                                    style={html?.badges?.micro}>
                                                                    {serviceDocuments?.length > 0 ? (
                                                                        <><i className={`${icons?.fasFa?.checkCircle} mr-1`} /> {labels?.active?.[languageObj?.id] || 'Active'}</>
                                                                    ) : (
                                                                        <><i className={`${icons?.fasFa?.timesCircle} mr-1`} /> {labels?.inactive?.[languageObj?.id] || 'Inactive'}</>
                                                                    )}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='d-flex flex-wrap justify-content-end align-items-center w-100 mt-3 mb-2'
                                                    style={{ gap: '8px' }}>
                                                    <button ref={btnDetailRef}
                                                        id={controls?.buttons?.detail?.id}
                                                        className={controls?.buttons?.detail?.defaultClass}
                                                        hidden
                                                        style={{ borderRadius: '5px' }}
                                                        tooltip='tooltip'
                                                        title={labels?.detail?.[languageObj?.id]}
                                                        type='button'
                                                        onClick={(e) => showServiceDocumentDetail({ subMethod: e?.currentTarget?.id, })}>
                                                        {!process?.detail ? (
                                                            <i id={controls?.icons?.detail?.id} className={controls?.icons?.detail?.defaultClass} />
                                                        ) : (
                                                            <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                        )} {labels?.detail?.[languageObj?.id]}
                                                    </button>
                                                    <button id={controls?.buttons?.back?.id}
                                                        className={controls?.buttons?.back?.defaultClass}
                                                        style={{ borderRadius: '5px' }}
                                                        disabled={process?.back || process?.showLoading}
                                                        tooltip='tooltip'
                                                        title={labels?.back?.[languageObj?.id]}
                                                        type='reset'
                                                        onClick={(e) => goToBack({ e: e, subMethod: controls?.buttons?.back?.id })}>
                                                        {!process?.back ? (
                                                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.defaultClass} />
                                                        ) : (
                                                            <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                        )} {labels?.back?.[languageObj?.id]}
                                                    </button>
                                                </div>

                                                {/* Section: Information Documents */}
                                                <div className='d-flex align-items-center mt-4 mb-2'>
                                                    <div className='bg-light p-1 rounded-circle mr-2 shadow-sm' style={{ width: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <i className={`${icons?.fasFa?.fileAlt} text-secondary`} style={{ fontSize: '12px' }}></i>
                                                    </div>
                                                    <h6 className='mb-0 font-weight-bold text-dark'>{labels?.informationDocuments?.[languageObj?.id]}</h6>
                                                </div>
                                                <TableIndex tableId={dtDocumentInformationsId} languageObj={languageObj} />

                                                {/* Section: Service Documents */}
                                                <div className='d-flex align-items-center mt-4 mb-2'>
                                                    <div className='bg-light p-1 rounded-circle mr-2 shadow-sm' style={{ width: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <i className={`${icons?.fasFa?.folderOpen} text-secondary`} style={{ fontSize: '12px' }}></i>
                                                    </div>
                                                    <h6 className='mb-0 font-weight-bold text-dark'>{labels?.serviceDocuments?.[languageObj?.id]}</h6>
                                                </div>
                                                <TableIndex tableId={dtServiceDocumentsId} languageObj={languageObj} />
                                            </div>
                                        </div>
                                    ) : (
                                        <div></div>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <AccessDenied languageObj={languageObj} />
                        )}
                    </div>
                </section>

            </div>

            {modalObj?.showModal && (
                <ServiceDocumentDetails auth={auth}
                    modalObj={modalObj}
                    setModalObj={setModalObj} />
            )}
        </div>
    )
}